/* quick-buy-lock.js — B2B gate on the Stock Order table (06.09.2026).
   Loaded only for visitors who are not unlocked (see section
   main-collection-graphql-quick-buy). Positions the "Register to unlock"
   layer over the locked columns (promo price … discount) so the CTA sits
   centred on the greyed-out area and follows the viewport while scrolling
   through the table. Cells themselves are rendered inert by
   quick-buy-product-renderer.js; this file is layout only. */
(function () {
  'use strict';

  var MOBILE_MAX = 989;

  /* 06.09.2026: EAN-Zellen sind fuer Gaeste vom Kopieren ausgenommen —
     user-select:none traegt die Hauptlast, dieser Handler faengt den Rest
     (z. B. Kontextmenue-Kopie einer bestehenden Auswahl) ab. */
  function inBarcode(node) {
    var el = node && (node.nodeType === 1 ? node : node.parentElement);
    return !!(el && el.closest && el.closest('.qb-product-barcode'));
  }
  document.addEventListener('copy', function (e) {
    var sel = document.getSelection();
    if (!sel || sel.isCollapsed) return;
    if (inBarcode(sel.anchorNode) || inBarcode(sel.focusNode)) e.preventDefault();
  });

  function init() {
    var root = document.querySelector('[data-qb-locked]');
    if (!root) return;
    var layer = root.querySelector('[data-qb-lock-layer]');
    var table = root.querySelector('table.qb-product-table');
    var body = root.querySelector('#QuickBuyTableBody');
    if (!layer || !table || !body) return;
    var container = layer.parentNode;

    function place() {
      var hasRows = !!body.querySelector('tr.qb-row');
      layer.hidden = !hasRows;
      if (!hasRows) return;

      if (window.innerWidth <= MOBILE_MAX) {
        layer.style.left = '';
        layer.style.width = '';
        layer.style.top = '';
        layer.style.height = '';
        return;
      }

      var ths = table.querySelectorAll('thead th');
      // Locked columns: 5 (promo price) … 8 (discount) — 1-based.
      var first = ths[4];
      var last = ths[7] || ths[ths.length - 1];
      if (!first || !last) return;
      var c = container.getBoundingClientRect();
      var f = first.getBoundingClientRect();
      var l = last.getBoundingClientRect();
      var b = body.getBoundingClientRect();
      layer.style.left = Math.round(f.left - c.left) + 'px';
      layer.style.width = Math.round(l.right - f.left) + 'px';
      layer.style.top = Math.round(b.top - c.top) + 'px';
      layer.style.height = Math.round(b.height) + 'px';
    }

    var timer = 0;
    function schedule() {
      if (timer) return;
      timer = window.setTimeout(function () { timer = 0; place(); }, 16);
    }

    new MutationObserver(schedule).observe(body, { childList: true, subtree: true });
    window.addEventListener('resize', schedule);
    window.addEventListener('load', schedule);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(schedule);
    place();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
